import React, { useState } from "react";
import { IoMdHelpCircleOutline } from "react-icons/io";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

const ContactUs = () => {
  const [openTab, setOpenTab] = useState(false);

  return (
    <div>
      <div
        onClick={() => {
          window.HubSpotConversations.widget.open();
          // setOpenTab(true)
        }}
        className="flex cursor-pointer items-center gap-2"
      >
        <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
          <IoMdHelpCircleOutline size={20} className="text-primary" />
        </div>

        <div>
          <h1 className="font-semibold">Contact us</h1>
          <p className="text-[12px] font-medium text-gray-500 dark:text-darkGray">
            Help or contact Billzpay
          </p>
        </div>
      </div>

      <AlertDialog open={openTab} onOpenChange={setOpenTab}>
        <AlertDialogContent className="font-jakarta">
          <AlertDialogHeader>
            <AlertDialogTitle>Contact Us</AlertDialogTitle>
            <AlertDialogDescription>
              You are about to be redirected to our WhatsApp contact. Would you
              like to continue?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-white outline-none">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={() =>
                window.open("https://wa.me/message/FOHLE6MHV7BRM1", "_blank")
              }
            >
              Continue
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default ContactUs;
